import React from "react";
import Link from "./Link";

/**
 * @typedef {{ uri: string, menu_uri: string, title: string }} CmsNavItem
 */

/**
 * Renders a CMS nav as a collection of links.
 *
 * @param {{nav?: Array<CmsNavItem>, onNavClick?: () => void, children: React.ElementType }} props
 */
var Nav = function Nav(_ref) {
  var nav = _ref.nav,
    onNavClick = _ref.onNavClick,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "cms--nav"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cms--menu-links"
  }, nav && nav.map(function (n) {
    return /*#__PURE__*/React.createElement(Link, {
      key: n.uri,
      to: n.menu_uri,
      onClick: function onClick() {
        return onNavClick && onNavClick();
      }
    }, n.title);
  })), children);
};
export default Nav;